<div>
  <!-- <em
    *ngIf="is_display && show_sku_list"
    class="hide-sku-icon bi bi-chevron-double-left"
    (click)="show_sku_list = !show_sku_list"
  ></em> -->

  <mat-sidenav-container
    class="side-nav-container"
    *ngIf="is_display"
    [hasBackdrop]="false"
  >
    <mat-sidenav opened mode="side">
      <app-sku-new-component
        [planogram_id]="planogram_id"
        [drop_item_ids]="drop_item_ids"
        [placed_sku_list]="placed_sku_list"
        [isReset]="isReset"
        (resetSkusInPlanogram)="resetPlanogram($event)"
      ></app-sku-new-component>
    </mat-sidenav>
    <mat-sidenav
      opened
      mode="side"
      position="end"
      class="recommandation-sidenav"
    >
      <div style="height: 100%">
        <as-split direction="horizontal">
          <as-split-area [size]="100">
            <as-split direction="vertical">
              <as-split-area [size]="75" class="right-padding-split-area">
                <div id="metric-calculation-container">
                  <app-side-accordian
                    [planogram_details]="planogram_details"
                    [planogram_id]="planogram_id"
                    [reset]="isReset"
                  ></app-side-accordian>
                </div>
              </as-split-area>
            </as-split>
          </as-split-area>
        </as-split>
      </div>
      <!-- <div
        *ngIf="isReset"
        style="
          width: 25vw;
          position: absolute;
          height: 100%;
          background-color: rgb(232, 231, 231);
          background-color: rgb(227 212 212);
          opacity: 0.5;
          z-index: 2;
          top:0;
        "
      ></div> -->
    </mat-sidenav>
    <app-planogram-new-component
      [drop_item_ids]="drop_item_ids"
      (newDropItemIdEvent)="addDropItemId($event)"
      [placed_sku_list]="placed_sku_list"
      [planogram_details]="planogram_details"
      [reset]="isReset"
      [save]="save"
    >
    </app-planogram-new-component>
  </mat-sidenav-container>
</div>
